import React, { useEffect, useState } from 'react';
import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import { Drawer, Tabs, Table } from 'antd';
import { parseColumnsForRunInstanceActivityLog } from './utils';
import style from './index.scss';

const { TabPane } = Tabs;

export const ViewExecutionActivityLog = ({
  onClose,
  visible,
  selectedData,
  apiActions,
  GS,
  runInstanceViewExecution
}) => {
  const { isLoading, data } = runInstanceViewExecution;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    apiActions?.getRunInstanceViewExecution({
      id: selectedData.id,
      offset: (currentPage - 1) * pageSize,
      limit: pageSize
    });
  }, [pageSize, currentPage]);

  const onPaginationChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
  };

  const columns = parseColumnsForRunInstanceActivityLog(GS && GS.widgetConfig);

  return (
    <Drawer
      title={`${selectedData?.id} ${selectedData?.name}`}
      placement="right"
      onClose={onClose}
      visible={visible}
      width={800}
      className={style.activityDrawer}>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Activity Log" key="1">
          <Table
            id="runInstanceActiviyLog"
            className={style.table}
            dataSource={data?.payload}
            columns={columns}
            loading={isLoading}
            rowKey="id"
            pagination={{
              showSizeChanger: true,
              responsive: false,
              total: data?.total,
              current: currentPage,
              pageSize,
              onChange: onPaginationChange,
              pageSizeOptions: [5, 10, 25, 50, 100],
              showTotal: (total) => `${total} Records`
            }}
          />
        </TabPane>
        <TabPane tab="Report" key="2">
          Report are coming soon...
        </TabPane>
      </Tabs>
    </Drawer>
  );
};

ViewExecutionActivityLog.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  selectedData: PropTypes.object.isRequired,
  apiActions: PropTypes.object.isRequired,
  GS: PropTypes.object.isRequired,
  runInstanceViewExecution: PropTypes.object.isRequired
};

export default ViewExecutionActivityLog;
